import { queryOptions, useQuery } from '@tanstack/react-query'

import { TagsApi } from '../api/tagsApi'

export const tagsQueryOptions = queryOptions({
  queryKey: ['tags'],
  queryFn: () => TagsApi.getTags(),
})

export const useTagsQuery = () =>
  useQuery({
    ...tagsQueryOptions,
    select: (data) => data.filter((tag) => tag.visible),
  })
